import ForbiddenError from './error';
import env from './env';

export const fetchSiteUtilisation = async (customer_id, site_id, token) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') +
      '/v3/quota/utilisation/' +
      site_id +
      '?customer_id=' +
      customer_id,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  )
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const fetchSiteQuotaStatus = async (customer_id, site_id, token) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/status/' + site_id + '?customer_id=' + customer_id,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  )
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};
